var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIlustrationContact(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 260,
    height: 264,
    viewBox: "0 0 260 264",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1522_3508)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 129.563,
    cy: 131.918,
    rx: 129.563,
    ry: 131.918,
    fill: "url(#paint0_radial_1522_3508)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.561 218.455C175.929 218.455 213.517 179.947 213.517 132.445C213.517 84.9424 175.929 46.4341 129.561 46.4341C83.193 46.4341 45.6044 84.9424 45.6044 132.445C45.6044 179.947 83.193 218.455 129.561 218.455Z",
    fill: "url(#paint1_linear_1522_3508)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1522_3508",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(59.7981 76.1066) rotate(39.3587) scale(232.018 232.874)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.566108
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.661829,
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.822917,
    stopColor: "#1B1B23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994792,
    stopColor: "#2B2C2E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1522_3508",
    x1: 129.561,
    y1: 2.92353,
    x2: 129.561,
    y2: 270.294,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E0A30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2484,
    stopColor: "#0E0A32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3927,
    stopColor: "#100B3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5104,
    stopColor: "#130D49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6137,
    stopColor: "#17105D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7067,
    stopColor: "#1C1476"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7387,
    stopColor: "#1E1581"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E15C5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1522_3508"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 259.125,
    height: 263.836,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIlustrationContact);
export default __webpack_public_path__ + "static/media/ilustration_contact.138d101a91caa2efe703a5cf0a4531fb.svg";
export { ForwardRef as ReactComponent };